// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aoshkotqiqiaeuabrzbf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFvc2hrb3RxaXFpYWV1YWJyemJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0MzkzNTYsImV4cCI6MjA3MzAxNTM1Nn0.HrNIQ8VJ9VoR3_wdCDaBaibSd1EqXcsGmA1YwNW2udg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});